export default "__VITE_ASSET__CjYD8A9e__"